import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { NavigationStart} from "@angular/router";
import { UnsafeAction } from "./UnsafeAction"

@Injectable()
export class RoutingActions {

	static ROUTING_EVENT_START = '[ROUTING] ROUTE NavigationStart';
	routingStart(event:NavigationStart):UnsafeAction {
		return {
			type: RoutingActions.ROUTING_EVENT_START,
			payload: event
		};
	}

}


// WEBPACK FOOTER //
// ./src/app/actions/routing.actions.ts